import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=72939cfc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72939cfc')) {
      api.createRecord('72939cfc', component.options)
    } else {
      api.reload('72939cfc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=72939cfc&", function () {
      api.rerender('72939cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-256niUNAB3Yvg/JS/offershelp.vue"
export default component.exports